const ConfettiColorsData = [
  {
    // colorful colors
    colors: [
      '#e91c3c',
      '#f67d1d',
      '#f6b71d',
      '#2b580c',
      '#129692',
      '#3b4ebe',
      '#cb2a99',
      '#8b25ba',
      '#3d3d3d',
      '#ffffff',
      '#808080',
      '#633f1b',
    ],
    page: ['rcw'],
  },
  {
    colors: ['#D50A0A', '#013369', '#FFFFFF'],
    page: ['nfl', 'nba'],
  },
  {
    colors: ['#BF0D3E', '#041E42', '#FFFFFF'],
    page: ['mlb'],
  },
]

export default ConfettiColorsData
